import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Message, Modal } from '@arco-design/web-vue';
import { useUserStore } from '@/store';

const { VITE_API_URL } = import.meta.env;

export interface HttpResponse<T = unknown> {
  status: number;
  msg: string;
  code: number;
  data: T;
}

axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    config.baseURL = VITE_API_URL;
    if (!config.timeout) {
      config.timeout = 5000;
    }
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // do something
    return Promise.reject(error);
  }
);
// add response interceptors
axios.interceptors.response.use(
  (response: AxiosResponse<HttpResponse>) => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 20000) {
      Message.error({
        content: res.msg || 'Error',
        duration: 5 * 1000,
      });
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (
        [50008, 50012, 50014].includes(res.code)
        // && response.config.url !== '/api/user/info'
      ) {
        // Modal.error({
        //   title: '已登出',
        //   content: '登录态已过期，请重新登录。',
        //   okText: '重新登录',
        //   async onOk() {
        const userStore = useUserStore();

        // await
        userStore.logout();
        window.location.reload();
        //   },
        // });
      }
      return Promise.reject(new Error(res.msg || 'Error'));
    }
    return res;
  },
  (error) => {
    const errMsg =
      error.response && error.response.data && error.response.data.msg
        ? error.response.data.msg
        : 'Error';
    Message.error({
      content: errMsg,
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);
